module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-7.962eb19f.png";